import { render, staticRenderFns } from "./GSTList.vue?vue&type=template&id=4acf45b2&"
import script from "./GSTList.vue?vue&type=script&lang=js&"
export * from "./GSTList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports